import axios from "axios";
import Config from "./../../config/index";
import RefreshTokenHandler from "./refresh-token";

/**
 *
 * @param email
 * @param amc_code
 * @param question
 * @param answer
 * @param status
 *
 */
const addFAQs = async (
  email: string,
  amc_code: string,
  question: string,
  answer: string,
  status: string = "false"
) => {
  const url = `${Config.baseUrl}/faq/`;
  try {
    const result: any = await axios.post(
      url,
      {
        email,
        amc_code,
        question,
        answer,
        status,
      },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      }
    );
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await addFAQs(email, amc_code, question, answer, status);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

/**
 *
 * @param email
 * @param amc_code
 *
 */
const getFAQs = async (email: string, amc_code: string) => {
  const url = `${Config.baseUrl}/faq/?email=${email}&amc_code=${amc_code}`;
  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getFAQs(email, amc_code);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

/**
 *
 * @param email
 * @param amc_code
 * @param id
 * @param question
 * @param answer
 */
const UpdateFAQs = async (
  email: string,
  amc_code: string,
  id: string,
  question: string,
  answer: string
) => {
  const url = `${Config.baseUrl}/faq/`;
  try {
    let result: any = await axios.put(
      url,
      { email, amc_code, id, question, answer },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      }
    );
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await UpdateFAQs(email, amc_code, id, question, answer);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};
/**
 *
 * @param email
 * @param amc_code
 * @param id
 * @param status
 */
const UpdateStatusFAQs = async (
  email: string,
  amc_code: string,
  id: string,
  status: string
) => {
  const url = `${Config.baseUrl}/faq/status`;
  try {
    let result: any = await axios.put(
      url,
      { email, amc_code, id, status },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      }
    );
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await UpdateStatusFAQs(email, amc_code, id, status);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

/**
 *
 * @param email
 * @param amc_code
 * @param title
 * @param description
 * @param status
 *
 */
const addGlossary = async (
  email: string,
  amc_code: string,
  title: string,
  description: string,
  status: string = "false"
) => {
  const url = `${Config.baseUrl}/glossary/`;
  try {
    const result: any = await axios.post(
      url,
      {
        email,
        amc_code,
        title,
        description,
        status,
      },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      }
    );
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await addGlossary(email, amc_code, title, description, status);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

/**
 *
 * @param email
 * @param amc_code
 * @param id
 * @param title
 * @param description
 */

/**
 *
 * @param email
 * @param amc_code
 * @param title
 * @param letter
//  * @param status
 *
 */
const getGlossary = async (
  email: string,
  amc_code: string,
  title: string,
  letter: string
) => {
  const url = `${Config.baseUrl}/glossary/?email=${email}&amc_code=${amc_code}&title=${title}&letter=${letter}`;
  try {
    const result: any = await axios.get(url, {
      headers: {
        Authorization: sessionStorage.getItem("token") || "",
      },
    });
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await getGlossary(email, amc_code, title, letter);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

const UpdateGlossary = async (
  email: string,
  amc_code: string,
  id: string,
  title: string,
  description: string
) => {
  const url = `${Config.baseUrl}/glossary/`;
  try {
    let result: any = await axios.put(
      url,
      { email, amc_code, id, title, description },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      }
    );
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await UpdateGlossary(email, amc_code, id, title, description);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

/**
 *
 * @param email
 * @param amc_code
 * @param id
 * @param status
 */
const UpdateStatusGlossary = async (
  email: string,
  amc_code: string,
  id: string,
  status: string
) => {
  const url = `${Config.baseUrl}/glossary/status`;
  try {
    let result: any = await axios.put(
      url,
      { email, amc_code, id, status },
      {
        headers: {
          Authorization: sessionStorage.getItem("token") || "",
        },
      }
    );
    return result;
  } catch (err: any) {
    if (err.response.data.status == 401) {
      let responseToHandle = err.response.data;
      let result = await RefreshTokenHandler.handleIt(responseToHandle);
      if (result.status) {
        return await UpdateStatusGlossary(email, amc_code, id, status);
      } else {
        throw err;
        // return result
      }
    } else {
      throw err;
    }
  }
};

export {
  addFAQs,
  UpdateFAQs,
  getFAQs,
  UpdateStatusFAQs,
  addGlossary,
  UpdateGlossary,
  getGlossary,
  UpdateStatusGlossary,
};
